export default __webpack_public_path__ + "static/media/icon_altAvatar.8e7c951b.svg";